// extracted by mini-css-extract-plugin
export default {"result__rank":"Result_result__rank__ilwPE","result__rank1":"Result_result__rank1__iSisO","header":"Result_header__32MoB","title":"Result_title__hc-Mz"};